{
  "nickname": "暱稱",
  "kyc": "身份驗證",
  "loginPassword": "登錄密碼",
  "txPassword": "交易密碼",
  "paymentMethod": "收款方式",
  "connectedApps": "已連接應用",
  "connectedAppsNotConnected": "未連接",
  "connectedAppsEmpty": "暫無已連接應用",
  "connectedAppsConnectedAt": "連接時間",
  "connectedAppsLastUsedAt": "最近使用",
  "connectedAppsDisconnect": "斷開",
  "connectedAppsDisconnectTitle": "斷開應用連接",
  "connectedAppsDisconnectDesc": "斷開後該應用將無法繼續使用寶幣支付。",
  "connectedAppsDisconnectSuccess": "已斷開連接",
  "connectedAppsDisconnectFailed": "斷開失敗",
  "connectAppTitle": "連接應用",
  "connectAppName": "應用名稱",
  "connectAppOrder": "應用訂單號",
  "connectAppExpiresAt": "過期時間",
  "connectAppConfirmDesc": "確認後，該應用可在你的授權下使用寶幣支付。",
  "connectAppConfirm": "確認連接",
  "connectAppApproveSuccess": "連接成功",
  "connectAppApproveFailed": "連接失敗",
  "notification": "通知設置",
  "contactCS": "聯繫客服",
  "cancel": "取消",
  "logout": "登出",
  "version": "版本"
}
